var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBranding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 35C0 54.33 15.67 70 35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35Z",
    fill: "#81061A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.23 40.13C49.23 42.61 50.67 44.06 53.16 44.06C50.68 44.06 49.23 45.5 49.23 47.99C49.23 45.51 47.79 44.06 45.3 44.06C47.77 44.06 49.22 42.62 49.23 40.13ZM46.12 45.71C46.12 47.54 47.19 48.62 49.03 48.62C47.2 48.62 46.12 49.69 46.12 51.53C46.12 49.7 45.05 48.62 43.21 48.62C45.04 48.63 46.12 47.56 46.12 45.71ZM18.65 19.29C18.65 20.96 19.62 21.93 21.3 21.94C19.63 21.94 18.66 22.91 18.65 24.59C18.65 22.92 17.68 21.95 16 21.94C17.67 21.94 18.64 20.97 18.65 19.29ZM21.42 11C21.42 14.33 23.36 16.28 26.71 16.29C23.38 16.29 21.43 18.23 21.42 21.58C21.42 18.25 19.48 16.3 16.13 16.29C19.46 16.29 21.42 14.35 21.42 11ZM24.01 19.32C24.01 21.8 25.45 23.25 27.94 23.25C25.46 23.25 24.01 24.69 24.01 27.18C24.01 24.7 22.57 23.25 20.08 23.25C22.55 23.26 24 21.81 24.01 19.32ZM37.87 29.45H27.77V30.62H37.87V29.45ZM38.21 24.71H27.29C26.45 24.71 25.76 25.41 25.76 26.25V28.57H39.75V26.25C39.74 25.4 39.05 24.71 38.21 24.71ZM38.75 37.3V54.62H26.89V37.3H38.75ZM37.54 31.5H28.1C25.99 31.5 24.27 33.24 24.27 35.36V56.28C24.27 57.55 25.31 58.6 26.57 58.6H39.08C40.35 58.6 41.38 57.56 41.38 56.28V35.36C41.37 33.23 39.65 31.5 37.54 31.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranding);
export default __webpack_public_path__ + "static/media/branding.374fe1f6824deb8b170fbfa2185002e8.svg";
export { ForwardRef as ReactComponent };